import { useState } from 'react';
import { IconAngleDown, IconAngleUp } from '@iwoca/icons';
import { Pill, Spinner } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { CopyButton } from 'components/CopyableText/CopyButton/CopyButton';
import { TStatePeople } from 'lendingApi/lendingApi.types';
import styles from './GuarantorsList.module.css';

type TProps = {
  isLoading: boolean;
  guarantors?: TStatePeople;
};

export const GuarantorsList = ({ isLoading, guarantors }: TProps) => {
  const [showAll, setShowAll] = useState(false);
  const DEFAULT_GUARANTORS_VISIBLE = 2;

  if (isLoading) {
    return <Spinner dataTestId="guarantors-spinner" />;
  }

  const guarantorNames = (guarantors || [])
    .filter((guarantor) => guarantor.roles?.includes('guarantor'))
    .map((guarantor) => `${guarantor.first_name} ${guarantor.last_name}`);

  if (!guarantorNames.length) {
    return null;
  }

  const ShowButton = (
    <ButtonLink
      className={styles.showButton}
      onClick={() => setShowAll((isShowing) => !isShowing)}
    >
      {showAll ? (
        <>
          <Trans>See less</Trans>
          <IconAngleUp />
        </>
      ) : (
        <>
          <Trans>See more</Trans>
          <IconAngleDown />
        </>
      )}
    </ButtonLink>
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.label}>
          <span>
            {guarantorNames.length > 1 ? t`Guarantors` : t`Guarantor`}
          </span>
          {guarantorNames.length > 1 && <Pill>{guarantorNames.length}</Pill>}
        </div>
        <div className={styles.guarantorsList}>
          {guarantorNames
            .slice(
              0,
              showAll ? guarantorNames.length : DEFAULT_GUARANTORS_VISIBLE,
            )
            .map((guatantor) => (
              <p key={guatantor} className={styles.guarantor}>
                {guatantor}
              </p>
            ))}
          {guarantorNames.length > DEFAULT_GUARANTORS_VISIBLE && ShowButton}
        </div>
      </div>

      <div className={styles.action}>
        <CopyButton
          buttonClassName={styles.copyButton}
          text={guarantorNames.join('\n')}
        />
      </div>
    </div>
  );
};
